module.exports = __webpack_public_path__ + "img/cooperation_unit_04.63c3663b.png";